import React from "react";
import { spring, useVideoConfig } from "remotion";

export interface SubtitleItem {
  from: number;
  to: number;
  text: string;
  highlight?: string;
}

export interface DynamicSubtitleProps {
  frame: number;
  subtitles: SubtitleItem[];
  bottom?: number; // Verified safe band: 380 - 420px
  highlightColor?: string;
  backgroundColor?: string;
  fontSize?: number;
}

export const DynamicSubtitle: React.FC<DynamicSubtitleProps> = ({
  frame,
  subtitles,
  bottom = 400, // Golden safe height (Y: 1520px, free from TikTok caption collision)
  highlightColor = "#FFB020",
  backgroundColor = "rgba(18, 10, 46, 0.94)",
  fontSize = 26,
}) => {
  const { fps } = useVideoConfig();
  const currentSub = subtitles.find((s) => frame >= s.from && frame < s.to);

  if (!currentSub) return null;

  const scale = spring({
    frame: frame - currentSub.from,
    fps,
    config: { damping: 14, stiffness: 180 },
  });

  return (
    <div
      style={{
        position: "absolute",
        bottom,
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        zIndex: 100,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          backgroundColor,
          backdropFilter: "blur(14px)",
          padding: "16px 36px",
          borderRadius: 24,
          border: "1px solid rgba(255, 255, 255, 0.16)",
          boxShadow: "0 15px 35px rgba(0,0,0,0.35)",
          maxWidth: 840,
          textAlign: "center",
          transform: `scale(${scale})`,
        }}
      >
        <span
          style={{
            fontFamily: "'Rajdhani', sans-serif",
            fontSize,
            fontWeight: 800,
            color: "#FFFFFF",
            lineHeight: 1.35,
          }}
        >
          {currentSub.highlight && currentSub.text.includes(currentSub.highlight) ? (
            (() => {
              const parts = currentSub.text.split(currentSub.highlight);
              return (
                <>
                  {parts[0]}
                  <span style={{ color: highlightColor }}>{currentSub.highlight}</span>
                  {parts.slice(1).join(currentSub.highlight)}
                </>
              );
            })()
          ) : (
            currentSub.text
          )}
        </span>
      </div>
    </div>
  );
};
